<template>
	<div class="banner">
		
		
		<div class="main-box">
			<div class="box-list">
				<img src="../assets/banner/pz2.png" alt="">
			</div>
			
			<div class="box-list">
				<img src="../assets/banner/pz1.png" alt="">
			</div>
			<div class="box-list">
				<img src="../assets/banner/pz3.png" alt="">
			</div>

		</div>







	</div>
</template>

<script>
  export default{
  	data(){
  		return{
        	// img1: require('@/resource/image/banner.jpg')
  		}
  	}
  }
</script>

<style scoped>
	.main-box{
		width: 1200px;
		margin: 0 auto;
		text-align: center;
	}
	.box-list{
		display: inline-block;
	}





</style>



// WEBPACK FOOTER //
// src/components/banner.vue